var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.963867H513V342.957H0V0.963867Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 0.958008V167.974L0 172.134V0.958008H513Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 171.966L0 342.962V0.958008L256.5 171.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7373 171.96C59.6142 173.484 59.5497 175.011 59.5439 176.539C59.5439 209.424 86.2029 236.084 119.089 236.084C151.975 236.084 178.634 209.425 178.634 176.539C178.634 174.997 178.556 173.472 178.441 171.96H59.7373Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.094 144.48C129.213 144.48 137.416 136.277 137.416 126.158C137.416 116.039 129.213 107.836 119.094 107.836C108.975 107.836 100.772 116.039 100.772 126.158C100.772 136.277 108.975 144.48 119.094 144.48Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8672 121.576V181.121C77.8672 212.677 119.092 222.345 119.092 222.345C119.092 222.345 160.316 212.677 160.316 181.121V121.576H77.8672Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.109 203.169C111.462 200.418 96.1885 193.383 96.1885 181.12V139.896H141.993V181.12C141.992 193.424 126.719 200.441 119.109 203.169Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.251 162.798V153.639L119.089 149.059L109.93 153.639V162.798L105.35 167.38V185.701H132.831V167.38L128.251 162.798Z",
    fill: "#F3F3F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.959961)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSx);
export default __webpack_public_path__ + "static/media/SX.c3cd353cbdb473a884c8f9392974a970.svg";
export { ForwardRef as ReactComponent };